(function (window, $, app) {
    var Math = window.Math;
    
    function Nav() {
        var _this = this;
        
        this.bind = function () {
            $('body').on('mouseenter', '.nav.\\--btns .nav\\.item.\\--has-children', function () {
                $(this).find('.nav\\.subnav').slideDown(app.ANIMATION_DURATION);
            }).on('mouseleave', '.nav.\\--btns .nav\\.item.\\--has-children', function () {
                $(this).find('.nav\\.subnav').slideUp(app.ANIMATION_DURATION);
            });
        };
    }
    
    app.registerModule('Nav', new Nav());
})(window, jQuery, app);
